import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-dark text-white text-center relative overflow-hidden" data-id="element-26">
      <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1518621736915-f3b1c41bfd00?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center" data-id="element-27"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          <div className="text-4xl mb-6" data-id="element-30">💫</div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-31">
            "El amor que mereces está esperándote del otro lado de tu decisión."
          </h2>

          <p className="text-xl text-gray-300 mb-4" data-id="element-32">
            No dejes que el miedo te mantenga un día más en el mismo patrón.
          </p>
          <p className="text-2xl font-bold text-gold-400 mb-12" data-id="element-33">
            Tu nueva vida amorosa empieza hoy.
          </p>

          <div className="bg-white/10 inline-block px-6 py-3 rounded-full mb-10 backdrop-blur-sm border border-white/20" data-id="element-34">
            <p className="text-sm sm:text-base text-gray-200" data-id="element-35">
              Este KIT era parte de mi Mentoria de{' '}
              <span className="font-bold text-white" data-id="element-36">+€1,000</span>, aprovecha
              el descuento solo por hoy.
            </p>
          </div>

          <a href="#pricing" className="block w-full sm:w-auto sm:inline-block bg-gold-500 hover:bg-gold-600 text-white font-bold text-xl py-5 px-10 rounded-full shadow-[0_0_30px_rgba(212,168,83,0.4)] transform transition hover:-translate-y-1" data-id="element-37">
            🔥 SÍ, QUIERO ROMPER MI BLOQUEO POR €27
          </a>
        </motion.div>
      </div>
    </section>;
}